<template>
    <div class="flex-fill">
        <div class="d-flex justify-content-center">
            <p class="panel-icon" :class="{ 'panel-icon-disabled': panelType.disabled }">
                <span class="icon create-panel-type-icon" :class="panelTypeIcon(panelType.value)"></span>
            </p>
        </div>
        <div>
            <div class="d-flex justify-content-center" style="margin-bottom: 5px">
                <span :class="{
                    'text-body': !panelType.disabled,
                    'text-secondary': panelType.disabled,
                }" class="medium panel-label align-middle">{{ panelTypeLabel(panelType.value) }}</span>
                <span v-if="panelType.paidOnly && freeTierActive"
                    class="badge badge-light badge-tiny ml-1 align-middle">Paid Only
                </span>
                <span v-else-if="panelType.disabled" class="ml-1 icon-glyphicons-basic-lock text-secondary"
                    data-toggle="popover" data-trigger="hover focus" data-content="Plan Upgrade Required"
                    data-placement="top" data-custom-class="text-center">
                </span>
                <div class="position-absolute d-flex align-items-center badge-container badge-container-left">
                    <span v-show="panelType.new && !panelType.disabled"
                        class="badge badge-highlight badge-tiny mr-1 align-middle">
                        <span class="align-middle">New</span>
                    </span>
                    <span v-show="panelType.beta" class="badge badge-highlight badge-tiny mr-1 align-middle">
                        <span class="icon icon-100 icon-glyphicons-basic-chemistry-alt mr-xs"></span>
                        <span class="align-middle">Beta</span>
                    </span>
                    <ai-badge v-if="panelType.ai" class="mr-1 d-flex" placement="top"
                        tooltip="AI-powered functions" :transparent="true"></ai-badge>
                </div>
                <div class="position-absolute d-flex align-items-center badge-container badge-container-right">
                    <info-popover v-if="panelType.walkthroughVideoUrl"
                        content="▶️ Click to watch a walkthrough video about this content type" placement="top"
                        class="video-walkthrough d-flex align-items-center">
                        <a @click.stop class="badge badge-purple-highlight badge-tiny"
                            :href="panelType.walkthroughVideoUrl" target="_blank">
                            <span class="icon icon-glyphicons-basic-video-play mr-1" style="font-size: 110%"></span>
                            <span class="align-middle">Watch</span>
                        </a>
                    </info-popover>
                </div>
            </div>
            <div class="text-secondary tiny text-center mb-1" style="max-height: 20px">
                {{ panelType.description }}
            </div>
        </div>
    </div>
</template>

<script>
import AiBadge from "@/components/AiBadge"
import InfoPopover from "@/components/InfoPopover"
import { panelTypeIcons, panelTypeLabels } from "@/assets/js/settings.js"

export default {
    name: "PanelTypeDisplay",
    components: {
        AiBadge,
        InfoPopover,
    },
    props: {
        panelType: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        panelTypeIcon(panelType) {
            return panelTypeIcons[panelType]
        },
        panelTypeLabel(panelType) {
            let label = ""
            try {
                label = panelTypeLabels[panelType]
            } catch (error) {
                label = "Content"
            }
            return label
        },
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/paneledit.scss";
@import "@/assets/styles/variables.scss";

.panel-icon {
    color: $secondary;
    margin-top: 12px;
    margin-bottom: 12px;
}

.panel-icon-disabled {
    color: #9ca5ad !important;
}

.panel-label {
    font-size: 14px;
    font-weight: 600;
}

.badge-container {
    height: 30px;
}

.badge-container-left {
    top: -1px;
    left: 5px;
}

.badge-container-right {
    top: -1px;
    right: 5px;
}
</style>